import * as React from "react";
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type {
  TypeChartLegendProps,
  TypeChartLegendTheme,
} from "./ChartLegendTypes";
import ChartLegendStyled from "./ChartLegendStyled";
import ChartLegendTailwind from "./ChartLegendTailwind";

const PALETTE_THEMES: TypeChartLegendTheme[] = [
  "compare",
  "contrast",
  "extended",
  "datavizRotation",
];

const ChartLegendHybrid = (props: TypeChartLegendProps) => {
  const { theme: paletteTheme, legendLabels, ...compatibilityProps } = props;
  const compatibilityRecord = compatibilityProps as Record<string, unknown>;
  const extensionProbe = { ...compatibilityProps };

  const useStyled =
    hasStyledProps(compatibilityProps) ||
    compatibilityRecord.cursor !== undefined ||
    compatibilityRecord.opacity !== undefined ||
    compatibilityRecord.size !== undefined ||
    compatibilityRecord.whiteSpace !== undefined ||
    compatibilityRecord.css !== undefined ||
    compatibilityRecord.forwardedAs !== undefined ||
    legendLabels.some((label) => Boolean(label.color)) ||
    isStyledExtension(extensionProbe) ||
    (paletteTheme !== undefined &&
      !PALETTE_THEMES.includes(paletteTheme as TypeChartLegendTheme));

  return useStyled ? (
    <ChartLegendStyled {...props} />
  ) : (
    <ChartLegendTailwind {...props} />
  );
};

export default ChartLegendHybrid;
